import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, catchError } from 'rxjs';
import { EncodingService } from './encoding.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})

export class GraphService {
  private graphEndpoint = 'https://graph.microsoft.com/v1.0/me/calendar/events';  
  private graphMailUrl = environment.backend_base_url;
  // private graphMailUrl = 'http://localhost:3000';

  constructor(
    private http: HttpClient,
    private encodingService: EncodingService
  ) {}

  createCalendarEvent(eventDetails: any): Observable<any> {
    const body = {
      subject: eventDetails.subject,
      body: {
        contentType: 'HTML',
        content: eventDetails.body,
      },
      start: {
        dateTime: eventDetails.startDateTime,
        //timezone easter standard time
        timeZone: 'Eastern Standard Time',
      },
      end: {
        dateTime: eventDetails.endDateTime,
        timeZone: 'Eastern Standard Time',
      },
      attendees: [
        {
          emailAddress: {
            address: 'broadcasting.scheduling@gm.com',
            name: 'Broadcast Scheduling',
          },
          type: 'Required',
        }, {
          emailAddress: {
            address: eventDetails.attendeeEmail,
            name: eventDetails.attendeeName,
          },
          type: 'Required',
        },
      ],
    };
    return this.http.post(this.graphEndpoint, body);
  }
  /**
   * Send a basic email using the endpoint
   * @param emailDetails - The details of the email to be sent
   * @returns Observable containing the response from the backend
   */
  sendGraphMail(emailDetails: any): Observable<any> {
    console.log("Original email details:", emailDetails);
    
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded email details:", encodedDetails);
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Email sent successfully:', response);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending email:', error);
        throw error;
      })
    );
  }

  sendSubmissionMail(emailDetails: any): Observable<any> { 
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded submission email details:", encodedDetails);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send/submit`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Submission email sent successfully:', response);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending submission email:', error);
        throw error;
      })
    );
  }

  sendToScheduleMail(emailDetails: any): Observable<any> {
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded schedule email details:", encodedDetails);
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send/schedule`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Schedule email sent successfully:', response, encodedDetails);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending schedule email:', error);
        throw error;
      })
    );
  }

  sendApproveMail(emailDetails: any): Observable<any> {
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded approve email details:", encodedDetails);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send/approve`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Approve email sent successfully:', response);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending approve email:', error);
        throw error;
      })
    );
  }

  sendLinkMail(emailDetails: any): Observable<any> {
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded link email details:", encodedDetails);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send/link`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Link email sent successfully:', response);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending link email:', error);
        throw error;
      })
    );
  }

  sendCompleteMail(emailDetails: any): Observable<any> {
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded complete email details:", encodedDetails);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send/complete`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Complete email sent successfully:', response);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending complete email:', error);
        throw error;
      })
    );
  }

  sendCancelMail(emailDetails: any): Observable<any> {
    // Encode the email details before sending
    const encodedDetails = this.encodingService.encodeObject(emailDetails);
    console.log("Encoded cancel email details:", encodedDetails);
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.graphMailUrl}/api/graph/send/cancel`, encodedDetails, { headers }).pipe(
      map((response: any) => {
        console.log('Cancel email sent successfully:', response);
        // Decode the response if needed
        return this.encodingService.decodeObject(response);
      }),
      catchError((error: any) => {
        console.error('Error sending cancel email:', error);
        throw error;
      })
    );
  }

  getCalendarEvents(): Observable<any> {
    return this.http.get(this.graphEndpoint).pipe(
      map((response: any) => response.value)
    );
  }
  getEventById(event_id: string): Observable<any> {
    const url = `${this.graphEndpoint}/${event_id}`;
    return this.http.get(url).pipe(
      map((response: any) => response)
    );
  }

}
